import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 4a4 4 0 1 1 0 8a4 4 0 0 1 0 -8","key":"svg-0"}],["path",{"d":"M12 12v8","key":"svg-1"}],["path",{"d":"M9 17l3 3l3 -3","key":"svg-2"}]]

const IconSwipeDown = createReactComponent('outline', 'swipe-down', 'SwipeDown', __iconNode);

export default IconSwipeDown;